import React from 'react';
import Container7 from '../../../../assets/images/Container-7.png';
import { Star } from 'lucide-react';

const ConsultationSection = () => {
  return (
    <div className="w-full bg-white py-16">
      <div className="w-full mx-auto">
        {/* Contenedor con borde punteado azul */}
        <div className="flex flex-col">
            {/* Banner azul superior */}
      <div className="bg-red-600 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Lado izquierdo - Estrellas y texto */}
            <div className="text-center lg:text-left">
              <div className="flex justify-center lg:justify-start items-center space-x-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-8 h-8 text-white fill-current" />
                ))}
              </div>
              <h2 className="text-2xl lg:text-3xl font-bold text-white leading-tight">
                A Leading Digital Marketing Agency For Small and Mid-Sized Businesses
              </h2>
            </div>

            {/* Lado derecho - Estadísticas */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-4xl lg:text-5xl font-bold text-white mb-2">15+</div>
                <div className="text-white text-sm font-medium">YEARS IN BUSINESS</div>
              </div>
              <div className="text-center">
                <div className="text-4xl lg:text-5xl font-bold text-white mb-2">1K+</div>
                <div className="text-white text-sm font-medium">ONLINE REVIEWS</div>
              </div>
              <div className="text-center">
                <div className="text-4xl lg:text-5xl font-bold text-white mb-2">50K+</div>
                <div className="text-white text-sm font-medium">CURRENT CLIENTS</div>
              </div>
              <div className="text-center">
                <div className="text-4xl lg:text-5xl font-bold text-white mb-2">2M+</div>
                <div className="text-white text-sm font-medium">LEADS</div>
              </div>
            </div>
          </div>
        </div>
      </div>
          <div className="flex flex-col lg:flex-row gap-12 items-center">
            
            {/* Lado izquierdo - Imagen */}
            <div className="w-full">
              <img 
                src={Container7} 
                alt="Professional team consultation" 
                className="w-full h-auto"
              />
            </div>

            {/* Lado derecho - Contenido de texto */}
            <div className="w-full  px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-6 leading-tight">
                Pick A Marketing Plan Best For Your Business
              </h2>
              
              <p className="text-gray-600 text-lg leading-relaxed mb-8">
                With various options available, from comprehensive digital campaigns to targeted local marketing efforts, finding the perfect fit ensures optimal results. By partnering with a trusted marketing provider like Azucarai, you can access expert guidance and tailored solutions, empowering you to make informed decisions and drive success in your marketing endeavors. Connect with our team to choose the best marketing plan or customized solution for your business.
              </p>

              <button className="bg-red-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-colors">
                SCHEDULE A CONSULTATION
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationSection;


